import React from 'react';
import useScrollReveal from '@/hooks/useScrollReveal';
import PillTag from '../PillTag';
import styles from './index.module.scss';

export interface TechFeatureRowProps {
  title: string;
  body: React.ReactNode;
  image: string;
  imageAlt: string;
  tags?: string[];
  reverse?: boolean;
  /** tech4：正文向右拉出 80，对齐稿面 464 宽 */
  bodyOutset?: boolean;
}

export default function TechFeatureRow({
  title,
  body,
  image,
  imageAlt,
  tags,
  reverse = false,
  bodyOutset = false,
}: TechFeatureRowProps) {
  const { ref, revealProps } = useScrollReveal<HTMLElement>();

  return (
    <article ref={ref} className={`${styles.row} ${reverse ? styles.reverse : ''}`} {...revealProps}>
      <div className={styles.visual}>
        <img src={image} alt={imageAlt} loading="lazy" />
      </div>
      <div className={styles.copy}>
        <div className={styles.heading}>
          <h3 className={styles.title}>{title}</h3>
          {tags && tags.length > 0 ? (
            <div className={styles.tags}>
              {tags.map((tag) => (
                <PillTag key={tag}>{tag}</PillTag>
              ))}
            </div>
          ) : null}
        </div>
        <div className={`${styles.body} ${bodyOutset ? styles.bodyOutset : ''}`}>{body}</div>
      </div>
    </article>
  );
}
